import React from 'react';
import { AlertCircle, AlertTriangle, CheckCircle, Info } from 'lucide-react'; // Import icons

const alertTypes = {
  error: {
    bg: 'bg-red-50',
    border: 'border-red-500',
    text: 'text-red-700',
    icon: AlertCircle,
  },
  warning: {
    bg: 'bg-tertiary-50',
    border: 'border-tertiary-500',
    text: 'text-tertiary-700',
    icon: AlertTriangle,
  },
  success: {
    bg: 'bg-secondary-50',
    border: 'border-secondary-500',
    text: 'text-secondary-700',
    icon: CheckCircle,
  },
  info: {
    bg: 'bg-primary-50',
    border: 'border-primary-500',
    text: 'text-primary-700',
    icon: Info,
  },
};

const Alert = ({ type = 'error', message, className = '' }) => {
  if (!message) return null;

  const config = alertTypes[type] || alertTypes.info;
  const Icon = config.icon;

  return (
    <div 
      className={`mb-6 border-l-4 p-4 rounded-md flex items-start ${config.bg} ${config.border} ${config.text} ${className}`} 
      role="alert"
    >
      <Icon className="h-5 w-5 mr-2 flex-shrink-0 mt-0.5" />
      {/* Use whitespace-pre-line to respect newlines in error messages */}
      <span className="whitespace-pre-line text-sm">{message}</span> 
    </div>
  );
};

export default Alert;
